export const generateAuthorizationToken = ({ accessKey, shortName }) => {
    try {
        return `Key ${btoa(`${shortName}:${atob(accessKey)}`)}`
    } catch (error) {
        console.error(error)
        return ""
    }
}